import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useTelemedicineUrlUpdateFeature} from 'presentation/hooks/useTelemedicineUrlUpdateFeature';
import {getHome} from '../../services/getHome';

export const useGetHomeQuery = (refetchOnMount?: boolean | 'always', enabled = true) => {
	const {isEnabled: useV3} = useTelemedicineUrlUpdateFeature();

	return useQuery({
		queryKey: [QUERY_KEYS.HOME, {useV3}],
		queryFn: ({signal}) => getHome({signal, useV3}),
		retry: 1,
		refetchOnMount,
		enabled,
	});
};
